import Link, { LinkProps } from 'next/link';
import { FunctionComponent } from 'react';
import BlueprintIcon from '../../../../components/BlueprintIcon';
import styles from './styles.module.scss';
import classnames from 'classnames';

export type BadgeProps = {
    className?: string;
    title: string;
    href: LinkProps['href'];
    onClick?: LinkProps['onClick'];
    icon: React.ReactElement;
    iconClassName?: string;
};

const Badge: FunctionComponent<BadgeProps> = ({
    title,
    href,
    className,
    icon,
    iconClassName,
    onClick,
}) => {
    const classNames = [styles.badge, className ? className : ''].join(' ');

    return (
        <Link
            className={classNames}
            onClick={onClick}
            href={href}
            aria-label={`Remove ${title} filter`}
            rel="nofollow"
        >
            <>
                <FacetIcon className={classnames(iconClassName)} icon={icon} />
                <span>{title}</span>
                <BlueprintIcon icon="Close" className={styles.closeIcon} />
            </>
        </Link>
    );
};

type FacetIconProps = {
    icon: React.ReactElement;
    className: string;
};

const FacetIcon: FunctionComponent<FacetIconProps> = ({ icon, className }) => {
    if (!icon) {
        return null;
    }

    return (
        <div aria-hidden="true" className={classnames(styles.icon, className)}>
            {icon}
        </div>
    );
};

export default Badge;
